import * as React from "react";
import { themeClassName } from "../utils/theme";

const Logo = (
  props: React.SVGProps<SVGSVGElement> & { mode?: "dark" | "light" },
) => {
  const theme = themeClassName();

  if (theme === "itexchangenet") {
    const src =
      props.mode === "light"
        ? "/itexchangenet-light.png"
        : "/itexchangenet-logo.png";
    return (
      <img
        src={src}
        alt="IT ExchangeNet"
        width={props.width}
        height={props.height}
        className={props.className}
        style={{
          objectFit: "contain",
          display: "block",
          ...(props.style as React.CSSProperties | undefined),
        }}
      />
    );
  }

  if (theme === "carson") {
    return (
      <svg
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        viewBox="0 0 1800 500.99"
        {...props}
      >
        <defs>
          <style>
            {`
      .cls-1 {
        fill: #0094d9;
      }

      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11 {
        stroke-width: 0px;
      }

      .cls-2 {
        fill: #0086bd;
      }

      .cls-3 {
        fill: #0077c1;
      }

      .cls-4 {
        fill: #0095d4;
      }

      .cls-5 {
        fill: #3ca7dd;
      }

      .cls-6 {
        fill: #72bde0;
      }

      .cls-7 {
        fill: #00a4e3;
      }

      .cls-8 {
        fill: #005e98;
      }

      .cls-9 {
        fill: #006db0;
      }

      .cls-10 {
        fill: #00477d;
      }

      .cls-12 {
        font-family: Avenir-Book, Avenir;
        font-size: 41.5px;
      }

      .cls-12, .cls-11 {
        fill: #fff;
      }
      `}
          </style>
        </defs>

        <g transform="scale(1.3) translate(-300, -350)">
          <path
            className="cls-2"
            d="M371.9,386.7c73.6-59.5,181.6-48,241.1,25.6,41.1,50.9,48.3,118.3,24.5,174.6,37.4-60.2,34.7-139.9-12.3-198.1-59.5-73.7-167.4-85.1-241.1-25.6-15.8,12.8-27.5,29.9-35.6,49.8,6.5-10,14.3-18.9,23.4-26.3"
          />
          <path
            className="cls-4"
            d="M401.9,417.1c4.1-5.4,8.7-10.4,13.9-14.6,53.9-43.6,132.9-35.2,176.5,18.7,43.6,53.9,35.2,132.9-18.7,176.5-36.5,29.5-75.9,51.1-111,45.3-29.7,5.8-58.4,7.9-82.6,3.2,1.4,1.9,2.9,3.9,4.3,5.7,59.5,73.6,141.7,37.5,215.3-22,15.4-12.5,28.1-27,37.9-43,23.8-56.4,16.6-123.7-24.5-174.6-59.5-73.6-167.5-85.1-241.1-25.6-9.1,7.4-16.9,16.3-23.4,26.3-7.6,18.6-12,39.5-13.6,61.3,15.4-26.7,38.3-48.4,67.1-57.2"
          />
          <path
            className="cls-6"
            d="M599.5,629.9c-73.7,59.5-155.8,95.6-215.3,22-1.5-1.8-2.9-3.8-4.3-5.7-12.5-2.4-23.7-6.7-33.4-13.1,7.2,15.8,15.7,30.2,25.5,42.3,59.5,73.6,141.7,37.5,215.3-22,22.7-18.4,39.5-41.3,50.1-66.5-9.9,15.9-22.5,30.5-37.9,43"
          />
          <path
            className="cls-3"
            d="M322.4,500.9c-11.8,32.5-13.8,68.1-3.8,95.6,6,16.5,15.6,28.3,27.9,36.6-17.8-39.3-26.8-87.5-24.1-132.2"
          />
          <path
            className="cls-5"
            d="M348.4,413c-15.8,24.2-24,55.1-26,87.9,3.3-9.2,7.5-18.2,12.4-26.6,1.6-21.8,6-42.7,13.6-61.3"
          />
          <path
            className="cls-8"
            d="M334.8,474.2c-4.9,8.5-9,17.4-12.4,26.6-2.7,44.7,6.3,92.9,24.1,132.2,9.6,6.5,20.9,10.7,33.4,13.1-32.1-43.5-49.6-111.2-45.1-172"
          />
          <path
            className="cls-10"
            d="M462.5,643c-16.7-2.8-32.5-11.8-46.6-29.2-39.3-48.7-51.7-146.2-14-196.7-28.8,8.8-51.7,30.5-67.1,57.2-4.5,60.8,13,128.5,45.1,172,24.2,4.7,52.9,2.6,82.6-3.2"
          />
          <path
            className="cls-5"
            d="M579.7,493c22.2,61.2-19.3,125.9-92.7,144.4-8.2,2.1-16.3,3.9-24.4,5.5,35.1,5.9,74.5-15.7,111-45.3,53.9-43.6,62.3-122.6,18.7-176.5-43.6-53.9-122.6-62.3-176.5-18.7-5.2,4.2-9.9,9.2-13.9,14.6,1.5-.5,3-.9,4.6-1.3,73.4-18.5,151,16.1,173.2,77.3"
          />
          <path
            className="cls-9"
            d="M416,613.8c14.1,17.4,29.8,26.4,46.6,29.2,8.1-1.6,16.3-3.4,24.4-5.5,73.4-18.5,114.9-83.2,92.7-144.4-22.2-61.2-99.8-95.9-173.2-77.3-1.6.4-3.1.9-4.6,1.3-37.6,50.6-25.3,148.1,14,196.7M426.2,486.7c3.2-6.8,7.6-12.6,13.2-17.2,30.4-24.6,75-19.8,99.6,10.6,24.6,30.4,19.9,75-10.6,99.6-30.4,24.6-64.4,39.5-89,9.1-1.9-2.4-3.7-5-5.4-7.8-17.8.2-32.4-5.2-38.4-21.6-8.6-23.6,4.1-61.6,30.5-72.7"
          />
          <path
            className="cls-1"
            d="M503.5,516.7c9.2,25.3-8,52-38.3,59.7-10.7,2.7-21.4,4.5-31.2,4.6,1.7,2.8,3.5,5.4,5.4,7.8,24.6,30.4,58.5,15.5,89-9.1,30.4-24.6,35.2-69.2,10.6-99.6-24.6-30.4-69.2-35.2-99.6-10.6-5.6,4.5-10,10.4-13.2,17.2,1.9-.8,3.8-1.4,5.8-2,30.3-7.7,62.4,6.7,71.6,31.9"
          />
          <path
            className="cls-7"
            d="M395.6,559.4c5.9,16.4,20.6,21.8,38.4,21.6-15.9-26-20.8-67.3-7.8-94.3-26.4,11.1-39.1,49.1-30.5,72.7"
          />
          <path
            className="cls-11"
            d="M811,413.6c-7-9.1-18.5-14.2-29.9-14.2-27.8,0-46.2,22.2-46.2,50.3s17.3,48.3,46.2,48.3,25-6.3,32.3-16.6l14.2,10.7c-3.7,5.1-18.5,21.7-46.9,21.7s-63.6-32.9-63.6-64,26.4-66.1,64.5-66.1,33.4,6.1,43.4,19.2l-14,10.7Z"
          />
          <path
            className="cls-11"
            d="M883.3,386.8h15.2l53,123.8h-19.6l-12.4-30.6h-58.9l-12.2,30.6h-19.6l54.5-123.8ZM913.3,465.3l-23.1-56.8h-.3l-23.4,56.8h46.9Z"
          />
          <path
            className="cls-11"
            d="M960.1,386.8h43.5c31.6,0,39.7,19.1,39.7,34.6s-11.7,30.6-30.4,32.7l35.1,56.5h-21l-31.5-54.5h-18.7v54.5h-16.8v-123.8ZM976.8,441.4h22c13.3,0,26.6-3.1,26.6-19.9s-13.3-19.9-26.6-19.9h-22v39.9Z"
          />
          <path
            className="cls-11"
            d="M1063.6,484.8c5.9,9.1,16.2,13.3,26.2,13.3s24.7-7,24.7-20.6c0-28.5-61-10.8-61-59.1s12.2-34.6,42-34.6,26.4,2.8,35.7,14.2l-13.6,12.4c-4.2-6.5-12.4-10.8-22-10.8-18.5,0-24.1,11.2-24.1,18.9,0,31.3,61,12.6,61,57.2s-19.2,38.3-43,38.3-31.1-5.4-39.5-17.1l13.8-11.9Z"
          />
          <path
            className="cls-11"
            d="M1138.9,448.7c0-36.7,26.7-65,64.5-65s64.5,28.3,64.5,65-26.8,65-64.5,65-64.5-28.3-64.5-65M1250.1,448.7c0-27.1-18.4-49.3-46.7-49.3s-46.7,22.2-46.7,49.3,18.4,49.3,46.7,49.3,46.7-22.2,46.7-49.3"
          />
          <polygon
            className="cls-11"
            points="1278.1 386.8 1300.1 386.8 1368.3 488.6 1368.7 488.6 1368.7 386.8 1385.5 386.8 1385.5 510.6 1364.1 510.6 1295.2 408.9 1294.9 408.9 1294.9 510.6 1278.1 510.6 1278.1 386.8"
          />
          <polygon
            className="cls-11"
            points="723.6 531.1 748.6 531.1 788 624.8 788.7 624.8 827.6 531.1 852.6 531.1 852.6 654.9 835.9 654.9 835.9 553.1 835.5 553.1 793.7 654.9 782.5 654.9 740.8 553.1 740.4 553.1 740.4 654.9 723.6 654.9 723.6 531.1"
          />
          <path
            className="cls-11"
            d="M926.3,594c-5.8-6.1-11.9-9.3-20.6-9.3-17.1,0-25.9,13.8-25.9,29.4s10.5,28.1,26.7,28.1,14.9-3.1,20.1-9.3l11.2,11.2c-8.2,9.1-19.4,12.8-31.5,12.8-25.5,0-43.4-17.7-43.4-43.2s17.5-43.7,43.4-43.7,23.6,4.2,31.8,13.1l-11.9,10.8Z"
          />
          <path
            className="cls-11"
            d="M948.5,531.1h43.2c52.3,0,65,39,65,61.9s-23.6,61.9-67.8,61.9h-40.4v-123.8ZM965.3,639.2h21.2c28.3,0,52.5-15.6,52.5-46.2s-8.2-46.2-48.4-46.2h-25.2v92.3Z"
          />
          <path
            className="cls-11"
            d="M1066.2,593c0-36.7,26.8-65,64.5-65s64.5,28.3,64.5,65-26.8,65-64.5,65-64.5-28.3-64.5-65M1177.4,593c0-27.1-18.4-49.3-46.7-49.3s-46.7,22.2-46.7,49.3,18.4,49.3,46.7,49.3,46.7-22.2,46.7-49.3"
          />
          <polygon
            className="cls-11"
            points="1193.6 531.1 1211.1 531.1 1238.4 630.1 1238.7 630.1 1267.9 531.1 1287.2 531.1 1316.4 630.1 1316.7 630.1 1344 531.1 1361.5 531.1 1325.5 654.9 1307.8 654.9 1277.7 553.8 1277.4 553.8 1247.5 654.9 1229.8 654.9 1193.6 531.1"
          />
          <polygon
            className="cls-11"
            points="1370.1 531.1 1450 531.1 1450 546.8 1386.9 546.8 1386.9 583.7 1445.6 583.7 1445.6 599.5 1386.9 599.5 1386.9 639.2 1453.1 639.2 1453.1 654.9 1370.1 654.9 1370.1 531.1"
          />
          <polygon
            className="cls-11"
            points="1464.7 531.1 1481.5 531.1 1481.5 639.2 1538.3 639.2 1538.3 654.9 1464.7 654.9 1464.7 531.1"
          />
          <polygon
            className="cls-11"
            points="1547.9 531.1 1564.7 531.1 1564.7 639.2 1621.5 639.2 1621.5 654.9 1547.9 654.9 1547.9 531.1"
          />
        </g>
      </svg>
    );
  }

  if (props.mode && props.mode === "light") {
    return (
      <svg
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1722 445.99"
        {...props}
      >
        <defs>
          <style>
            {
              ".cls-1 { fill: #A56CFF;}  .cls-1, .cls-2 { stroke-width: 0px; } .cls-2 { fill: #2F007A; }"
            }
          </style>
        </defs>
        <g>
          <path
            className="cls-2"
            d="M578.19,56.33h54.27v261.1h133.89v45.82h-188.16V56.33Z"
          />
          <path
            className="cls-2"
            d="M819.59,38.54c18.68,0,33.36,14.68,33.36,32.47,0,18.68-14.68,32.47-33.36,32.47s-32.02-13.79-32.02-32.47,14.23-32.47,32.02-32.47ZM793.34,131.95h52.94v231.3h-52.94v-231.3Z"
          />
          <path
            className="cls-2"
            d="M1064.64,332.12h-.89c-13.79,20.9-42.71,37.36-78.29,37.36-64.94,0-113.43-52.49-113.43-121.43s49.82-122.32,113.43-122.32c36.02,0,67.61,17.79,80.95,40.92h.89v-34.7h50.26v314.04h-52.93v-113.87ZM996.59,322.33c40.92,0,69.39-32.47,69.39-74.73s-28.47-75.17-69.39-75.17-69.4,32.92-69.4,75.17,28.47,74.73,69.4,74.73Z"
          />
          <path
            className="cls-2"
            d="M1151.36,279.63v-147.68h53.37v138.79c0,34.25,22.69,51.6,52.94,51.6s53.38-17.35,53.38-51.6v-138.79h52.93v147.68c0,50.27-40.48,89.86-106.31,89.86s-106.31-39.59-106.31-89.86Z"
          />
          <path
            className="cls-2"
            d="M1424.01,38.54c18.68,0,33.36,14.68,33.36,32.47,0,18.68-14.68,32.47-33.36,32.47s-32.02-13.79-32.02-32.47,14.23-32.47,32.02-32.47ZM1397.77,131.95h52.94v231.3h-52.94v-231.3Z"
          />
          <path
            className="cls-2"
            d="M1476.47,247.16c0-68.95,48.48-121.43,113.43-121.43,35.58,0,64.49,16.46,78.29,37.36h.89V29.64h52.93v333.61h-50.26v-34.25h-.89c-13.34,23.13-44.93,40.48-80.95,40.48-63.61,0-113.43-52.05-113.43-122.32ZM1601.02,322.78c40.92,0,69.39-32.91,69.39-74.73s-28.47-75.17-69.39-75.17-69.4,32.47-69.4,75.17,28.47,74.73,69.4,74.73Z"
          />
        </g>
        <path
          className="cls-2"
          d="M77.86,341.72V78.04h0c-43,0-77.86,34.86-77.86,77.86v188.74c0,41.39,33.55,74.94,74.94,74.94h188.75c43,0,77.86-34.86,77.86-77.86h0s-263.68,0-263.68,0Z"
        />
        <path
          className="cls-1"
          d="M344.64,0h-188.75c-43,0-77.86,34.86-77.86,77.86h208.63l-143.43,143.43,55.05,55.05,143.43-143.43v208.63h0c43,0,77.86-34.86,77.86-77.86V74.94c0-41.39-33.55-74.94-74.94-74.94Z"
        />
      </svg>
    );
  }

  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1722 445.99"
      {...props}
    >
      <defs>
        <style>
          {
            ".cls-1 { fill: #a56cff;}  .cls-1, .cls-2 { stroke-width: 0px; } .cls-2 { fill: #f2f2f2; }"
          }
        </style>
      </defs>
      <g>
        <path
          className="cls-2"
          d="M578.19,56.33h54.27v261.1h133.89v45.82h-188.16V56.33Z"
        />
        <path
          className="cls-2"
          d="M819.59,38.54c18.68,0,33.36,14.68,33.36,32.47,0,18.68-14.68,32.47-33.36,32.47s-32.02-13.79-32.02-32.47,14.23-32.47,32.02-32.47ZM793.34,131.95h52.94v231.3h-52.94v-231.3Z"
        />
        <path
          className="cls-2"
          d="M1064.64,332.12h-.89c-13.79,20.9-42.71,37.36-78.29,37.36-64.94,0-113.43-52.49-113.43-121.43s49.82-122.32,113.43-122.32c36.02,0,67.61,17.79,80.95,40.92h.89v-34.7h50.26v314.04h-52.93v-113.87ZM996.59,322.33c40.92,0,69.39-32.47,69.39-74.73s-28.47-75.17-69.39-75.17-69.4,32.92-69.4,75.17,28.47,74.73,69.4,74.73Z"
        />
        <path
          className="cls-2"
          d="M1151.36,279.63v-147.68h53.37v138.79c0,34.25,22.69,51.6,52.94,51.6s53.38-17.35,53.38-51.6v-138.79h52.93v147.68c0,50.27-40.48,89.86-106.31,89.86s-106.31-39.59-106.31-89.86Z"
        />
        <path
          className="cls-2"
          d="M1424.01,38.54c18.68,0,33.36,14.68,33.36,32.47,0,18.68-14.68,32.47-33.36,32.47s-32.02-13.79-32.02-32.47,14.23-32.47,32.02-32.47ZM1397.77,131.95h52.94v231.3h-52.94v-231.3Z"
        />
        <path
          className="cls-2"
          d="M1476.47,247.16c0-68.95,48.48-121.43,113.43-121.43,35.58,0,64.49,16.46,78.29,37.36h.89V29.64h52.93v333.61h-50.26v-34.25h-.89c-13.34,23.13-44.93,40.48-80.95,40.48-63.61,0-113.43-52.05-113.43-122.32ZM1601.02,322.78c40.92,0,69.39-32.91,69.39-74.73s-28.47-75.17-69.39-75.17-69.4,32.47-69.4,75.17,28.47,74.73,69.4,74.73Z"
        />
      </g>
      <path
        className="cls-2"
        d="M77.86,341.72V78.04h0c-43,0-77.86,34.86-77.86,77.86v188.74c0,41.39,33.55,74.94,74.94,74.94h188.75c43,0,77.86-34.86,77.86-77.86h0s-263.68,0-263.68,0Z"
      />
      <path
        className="cls-1"
        d="M344.64,0h-188.75c-43,0-77.86,34.86-77.86,77.86h208.63l-143.43,143.43,55.05,55.05,143.43-143.43v208.63h0c43,0,77.86-34.86,77.86-77.86V74.94c0-41.39-33.55-74.94-74.94-74.94Z"
      />
    </svg>
  );
};
export default Logo;
